import apiClient from './api';
import {
  LegislativeNotice,
  CreateLegislativeNoticeRequest,
  UpdateLegislativeNoticeRequest,
} from '../types';

export const legislativeNoticeService = {
  // 모든 입법예고 조회
  async getAllLegislativeNotices(): Promise<LegislativeNotice[]> {
    const response = await apiClient.get<LegislativeNotice[]>('/legislative-notices');
    return response.data;
  },

  // 특정 입법예고 조회
  async getLegislativeNotice(legislativeNoticeId: string): Promise<LegislativeNotice> {
    const response = await apiClient.get<LegislativeNotice>(`/legislative-notices/${legislativeNoticeId}`);
    return response.data;
  },

  // 입법예고 생성
  async createLegislativeNotice(legislativeNoticeData: CreateLegislativeNoticeRequest): Promise<LegislativeNotice> {
    const response = await apiClient.post<LegislativeNotice>('/legislative-notices', legislativeNoticeData);
    return response.data;
  },

  // 입법예고 수정
  async updateLegislativeNotice(legislativeNoticeId: string, legislativeNoticeData: UpdateLegislativeNoticeRequest): Promise<LegislativeNotice> {
    const response = await apiClient.patch<LegislativeNotice>(`/legislative-notices/${legislativeNoticeId}`, legislativeNoticeData);
    return response.data;
  },

  // 입법예고 삭제
  async deleteLegislativeNotice(legislativeNoticeId: string): Promise<void> {
    await apiClient.delete(`/legislative-notices/${legislativeNoticeId}`);
  },

  // 마감일 상태 확인
  async getDeadlineStatus(legislativeNoticeId: string): Promise<{ isDeadlinePassed: boolean }> {
    const response = await apiClient.get<{ isDeadlinePassed: boolean }>(`/legislative-notices/${legislativeNoticeId}/deadline-status`);
    return response.data;
  },

  // 입법예고 승인
  async approveLegislativeNotice(legislativeNoticeId: string): Promise<LegislativeNotice> {
    const response = await apiClient.post<LegislativeNotice>(`/legislative-notices/${legislativeNoticeId}/approve`);
    return response.data;
  },

  // 입법예고 승인 취소
  async unapproveLegislativeNotice(legislativeNoticeId: string): Promise<LegislativeNotice> {
    const response = await apiClient.post<LegislativeNotice>(`/legislative-notices/${legislativeNoticeId}/unapprove`);
    return response.data;
  },

  // 최근 입법예고 조회
  async getRecentLegislativeNotices(limit: number = 3): Promise<LegislativeNotice[]> {
    const response = await apiClient.get<LegislativeNotice[]>(`/legislative-notices?limit=${limit}&sortBy=createdAt&sortOrder=desc`);
    return response.data;
  },
}; 